module.exports = __webpack_public_path__ + "static/media/bags.cda01887.png";